
<h2>Summaries for {{opCoSelected}}</h2>
<ng-container>
  <p *ngIf="hasMockData">No data available, showing mock data.</p>
  <app-euds-accordion ariaLabel="Filters Section"
                      [allowMultiple]="false"
                      [numbered]="false"
                      [altHeadingColor]="false"
                      class="margin-bottom-5">
    <app-euds-accordion-item label="Filters" icon="feather/filter">
      <div class="summary-filters">
        <app-euds-textfilter label="Account Number"
                             [showResultMessage]="false"
                             [(ngModel)]="filterAccountNumber">
        </app-euds-textfilter>
        <app-euds-textfilter label="Customer Number"
                             [showResultMessage]="false"
                             [(ngModel)]="filterCustomerNumber">
        </app-euds-textfilter>
        <app-euds-textfilter label="Phone Number"
                             [showResultMessage]="false"
                             [(ngModel)]="filterPhoneNumber">
        </app-euds-textfilter>
        <app-euds-select label="Updated"
                         [required]="false"
                         textOptional=""
                         [(ngModel)]="filterLastUpdated"
                         [options]="optionsDateFilter"
                         (valueChange)="filterLastUpdatedValueChanged($event)">
        </app-euds-select>
        <app-euds-filter #eudsFilterChannel
                         label="Channel"
                         [options]="optionsChannelFilter"
                         [hideTextFilter]="true"
                         (selectedOptionsChanged)="filterChannelSelectedOptionsChanged($event)">
        </app-euds-filter>
        <app-euds-textfilter label="Summary"
                             [showResultMessage]="false"
                             [(ngModel)]="filterSummary">
        </app-euds-textfilter>
        <app-euds-date-picker *ngIf="showDateRangeFilter"
                              label="Updated Date Range"
                              textOptional=""
                              [required]="false"
                              dateFormat="mm/dd/yyyy"
                              [dateRange]="true"
                              dateRangeDatesDelimiter=" - "
                              [(ngModel)]="lastUpdatedDateRange"
                              (dateChanged)="lastUpdatedDateRangeChanged($event)">
        </app-euds-date-picker>
      </div>
      <div class="button-bar">
        <app-euds-button type="primary"
                         label="Apply Filters"
                         (clickEvent)="applyFilters()"></app-euds-button>
        <app-euds-button type="secondary"
                         label="Clear Filters"
                         (clickEvent)="clearFilters()"></app-euds-button>
      </div>
    </app-euds-accordion-item>
  </app-euds-accordion>
  <div class="button-bar-table">
    <app-euds-button type="secondary"
                     label="Refresh"
                     class="refresh-button"
                     icon="feather/refresh-cw"
                     iconPosition="left"
                     [disabled]="isLoading"
                     (clickEvent)="applyFilters(true)">
    </app-euds-button>
  </div>
  <app-euds-textfilter class="margin-top-2"
                       label="Search"
                       [hideLabel]="true"
                       placeholder="Search Summaries..."
                       [resultCount]="filterCount"
                       [showResultMessage]="true"
                       (valueChange)="filterDataSource($event)"
                       (blurEvent)="filterDataSource($event)"
                       (clearEvent)="resetDataSource($event)"
                       (enterEvent)="filterDataSource($event)">
    <span slot="result-message">{{resultMessageText}}</span>
  </app-euds-textfilter>
  <app-euds-data-table #tableSummaries class="margin-top-4"
                       *ngIf="displayedSummariesData?.length > 0"
                       [showCaption]="false"
                       caption="Summaries Table"
                       [condensed]="false"
                       [striped]="true"
                       [dataSource]="displayedSummariesData"
                       [columnDefs]="columnDefsSummaries"
                       (sortFunction)="sortTableData($event)">
    <ng-container *ngFor="let summary of displayedSummariesData; index as idx">
      <tr app-euds-table-row [index]="idx">
        <td app-euds-table-cell [innerHtml]="summary.accountNumber | highlight: searchText"></td>
        <td app-euds-table-cell [innerHtml]="summary.customerInfo?.customerNumber | highlight: searchText">{{summary.customerInfo?.customerNumber}}</td>
        <td app-euds-table-cell [innerHtml]="summary.customerInfo?.phoneNumber | highlight: searchText">{{summary.customerInfo?.phoneNumber}}</td>
        <td app-euds-table-cell>{{summary.lastUpdated | tzAbbr:currentTimeZone}}</td>
        <td app-euds-table-cell>
          <span class="info-with-icon">
            <app-euds-svg [icon]="getChannelIcon(summary.sourceChannel)" size="sm"></app-euds-svg>
            <span [innerHtml]="summary.sourceChannel | highlight: searchText"></span>
          </span>
        </td>
        <td app-euds-table-cell [innerHtml]="summary.summaryText | highlight: searchText"></td>
        <td app-euds-table-cell>
          <app-euds-button type="tertiary"
                           size="small"
                           label="Details"
                           [ariaControls]="'summary-drawer'"
                           [ariaExpanded]="isViewSummaryDetailsPanelOpen"
                           [ariaLabel]="'View Details for ' + summary.accountNumber"
                           (clickEvent)="clickViewSummaryDetails($event, summary)"></app-euds-button><br />
          <app-euds-button type="tertiary"
                           size="small"
                           label="Real-Time Preview"
                           [ariaLabel]="'Go to Real-Time Preview for ' + summary.accountNumber"
                           (clickEvent)="clickViewRealTimePreview($event, summary)"></app-euds-button><br />
          <app-euds-button type="tertiary"
                           size="small"
                           label="Raw JSON"
                           [ariaControls]="'summary-drawer'"
                           [ariaExpanded]="isViewJsonDetailsPanelOpen"
                           [ariaLabel]="'View Raw Json for ' + summary.accountNumber"
                           (clickEvent)="clickViewJsonDetails($event, summary)"></app-euds-button><br />
          <app-euds-button type="tertiary"
                           size="small"
                           label="Touchpoints"
                           [ariaLabel]="'Go to Touchpoints for ' + summary.accountNumber"
                           (clickEvent)="clickViewTouchpointDetails($event, summary)"></app-euds-button>
        </td>
      </tr>
    </ng-container>
  </app-euds-data-table>
  <p *ngIf="displayedSummariesData?.length === 0" class="margin-top-4">No records found.</p>
  <app-euds-pagination #paginationSummaries
                       *ngIf="displayedSummariesData?.length > 0"
                       [itemsPerPageOptions]="itemsPerPageOptions"
                       [itemsPerPage]="itemsPerPage"
                       [totalItems]="totalSummaries"
                       (changeItemsPerPage)="onChangeItemsPerPage($event);"
                       (changePage)="onChangePage($event);">
  </app-euds-pagination>
  <app-drawer #drawer
              id="summary-drawer"
              [heading]="drawerHeading"
              (onOpen)="onOpenDrawer($event)"
              (onClose)="onCloseDrawer($event)">
    <!-- Share button -->
    <div drawer-actions>
      <app-share *ngIf="isViewSummaryDetailsPanelOpen && selectedSummary" [data]="selectedSummary"></app-share>
    </div>
    <ng-container *ngIf="isViewSummaryDetailsPanelOpen">
      <app-summary-details [summary]="selectedSummary" [timezone]="currentTimeZone"></app-summary-details>
    </ng-container>
    <ng-container *ngIf="isViewJsonDetailsPanelOpen">
      <pre class="summary-details">
        {{selectedSummaryOutput}}
      </pre>
    </ng-container>
  </app-drawer>
  <app-euds-loader [visible]="isLoading"></app-euds-loader>
</ng-container>
